import React, { useState, useEffect } from "react";
import axios from "axios";
import { ItemRequisitionAPI } from "../ItemRequisitionAPI";
import { UserConsumer } from "../../../UserContext";
import { Table } from "../../../components/CustomPaginations";
import { tableStyle, TrimString } from "../../../components/TableStyle";
import { AlertPopups } from "../../../components/AlertPopups";
import paginationFactory, {
	PaginationProvider,
} from "react-bootstrap-table2-paginator";
import ActionFormatter from "./ActionFormatter";

function TagAssetsFormList(props) {
	let token = null;
	const { itemRequisitionId, setIsTagAssetLoaded } = props;
	const defaultSorted = [
		{
			dataField: "id",
			order: "asc",
		},
	];
	const [tableData, setTableData] = useState(null);
	const [pagerData, setPagerData] = useState(null);
	const [isLoading, setIsLoading] = useState(true);
	const [pageNum, setPageNum] = useState(1);
	const [sortBy, setSortBy] = useState(defaultSorted[0]);
	const [numberOfItemsPerPage, setNumberOfItemsPerPage] = useState(10);

	const customFormatter = (row) => (
		<ActionFormatter
		rowData={row}
		editFunction={() => props.editTagAssets(row)}
		id={row.id}
		deleteFunction={() => deleteTagAsset(row.id)}
	  />
	);

	const getColumns = [
		{
			dataField: "category",
			text: "Category",
			 title: true ,
			sort: true,
			headerStyle: {
				width: "25%",
			},
			formatter: TrimString,
		},
		{
			dataField: "assetCode",
			text: "Asset Code",
			 title: true ,
			sort: true,
		},
		{
			dataField: "serialNo",
			text: "Serial No",
			 title: true ,
			sort: true,
			formatter: TrimString,
		},
		{
			dataField: "description",
			text: "Description",
			 title: true ,
			sort: true,
			headerStyle: {
				width: "25%",
			},
			formatter: TrimString,
		},
		{
			dataField: "edit",
			text: "Edit",
			formatter: (cell, row) => customFormatter(row),
		},
	];

	useEffect(() => {
		getAllTagAssets();
	}, []);
	const getAllTagAssets = () => {
		axios
			.get(
				`${ItemRequisitionAPI.GetTagAssetsList}/${itemRequisitionId}/TagAssets?PageNumber=${pageNum}&PageSize=${numberOfItemsPerPage}&sortBy=${sortBy.dataField}_${sortBy.order}`,
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}
			)
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setTableData(res.data.tagAssets);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setIsTagAssetLoaded(true);
				}
			});
	};
	const deleteTagAsset = (id) => {
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		AlertPopups.confirmBox
			.fire({
				text: AlertPopups.confirmMsg,
			})
			.then((result) => {
				if (result.value) {
					setIsLoading(true);
					axios
						.delete(
							`${ItemRequisitionAPI.DeleteTagAsset}/${itemRequisitionId}/TagAssets/${id}`,
							{
								headers: headers,
							}
						)
						.then((res) => {
							if (res.status === 200) {
								setIsLoading(false);
								AlertPopups.InfoAlert.fire({
									text: "Tag Removed",
								});
								getAllTagAssets();
							}
						});
				}
			});
	};
	const receiveData = (PageSize) => {
		setIsLoading(true);
		let apiURL = `${
			ItemRequisitionAPI.GetTagAssetsList
		}/${itemRequisitionId}/TagAssets?PageSize=${PageSize}&PageNumber=${1}&sortBy=${
			sortBy.dataField
		}_${sortBy.order}`;
		axios
			.get(apiURL, {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			})
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setPageNum(1);
					setNumberOfItemsPerPage(PageSize);
					setTableData(res.data.tagAssets);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
				}
			});
	};
	const handleTableChange = (type, { page, sortOrder, sortField }) => {
		setIsLoading(true);
		let getData = false;
		let apiURL = "";

		if (type === "sort") {
			apiURL = `${ItemRequisitionAPI.GetTagAssetsList}/${itemRequisitionId}/TagAssets?PageSize=${numberOfItemsPerPage}&PageNumber=${page}&sortBy=${sortField}_${sortOrder}`;
			setSortBy({ dataField: sortField, order: sortOrder });
			getData = true;
		} else if (type === "pagination") {
			apiURL = `${ItemRequisitionAPI.GetTagAssetsList}/${itemRequisitionId}/TagAssets?PageSize=${numberOfItemsPerPage}&PageNumber=${page}&sortBy=${sortBy.dataField}_${sortBy.order}`;
			getData = true;
		}
		if (getData) {
			axios
				.get(apiURL, {
					headers: {
						Authorization: `Bearer ${token}`,
					},
				})
				.then((res) => {
					if (res.status === 200) {
						setIsLoading(false);
						setPageNum(page);
						setTableData(res.data.tagAssets);
						setPagerData(JSON.parse(res.headers["x-pagination"]));
					}
				});
		}
	};
	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				return (
					<div className="formTableList">
						{tableData ? (
							<PaginationProvider
								pagination={paginationFactory({
									custom: true,
									totalSize: pagerData
										? pagerData.TotalCount
										: 0,
									page: pageNum,
									sizePerPage: numberOfItemsPerPage,
									paginationSize: numberOfItemsPerPage,
								})}
							>
								{({
									paginationProps,
									paginationTableProps,
								}) => {
									return (
										<Table
											inputValue={""}
											keyField={"token"}
											columns={getColumns}
											items={tableData}
											headerClass={"sub-thead"}
											tableStyle={tableStyle}
											paginationProps={paginationProps}
											paginationTableProps={
												paginationTableProps
											}
											onTablePageChange={
												handleTableChange
											}
											defaultSorted={defaultSorted}
											showFeedback={true}
											tableLoader={isLoading}
											SearchBar={() => {
												return null;
											}}
											pagerData={pagerData}
											receiveData={(PageSize) => {
												receiveData(PageSize);
											}}
										/>
									);
								}}
							</PaginationProvider>
						) : null}
					</div>
				);
			}}
		</UserConsumer>
	);
}

export default TagAssetsFormList;
